import React, { useMemo } from 'react';
import { FieldError } from 'react-hook-form';
import MultiSelectWithCheckList from '../../../../../Base/Components/Inputs/MultiSelectWithCheckList/MultiSelectWithCheckList';
import { SelectValue } from '../../../../../../Components/Base/Select/Select';
import {
	PaginationOrderHow,
	useInsuranceCompanyBatchTypesQuery,
} from '../../../../../../graphql/graphql';
import Loading from '../../../../../../Components/Loading';

interface Props {
	onChange?: (value: SelectValue[]) => void;
	value?: SelectValue[];
	error?: FieldError;
	placeholder?: string;
	portal?: boolean;
}

const InsuranceCompanyBatchTypesMultiSelectWithCheckList: React.FC<Props> = ({
	value,
	onChange,
	portal,
	placeholder = 'base.shared.pick',
}) => {
	const { data, isLoading } = useInsuranceCompanyBatchTypesQuery({
		pagination: {
			take: 999,
			order: {
				key: 'value',
				how: PaginationOrderHow.Asc,
			},
		},
	});

	const options: SelectValue[] = useMemo(() => {
		const batchTypes = data?.insuranceCompanyBatchTypes?.data || [];

		return batchTypes
			.map(batchType => {
				if (batchType.id && batchType.name) {
					return {
						value: batchType.id,
						label: batchType.name,
					};
				}

				return undefined;
			})
			.filter(Boolean) as SelectValue[];
	}, [data]);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<MultiSelectWithCheckList
			options={options}
			onChange={onChange}
			value={value}
			placeholder={placeholder}
			portal={portal}
		/>
	);
};

export default InsuranceCompanyBatchTypesMultiSelectWithCheckList;
